import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

export const setMetadata = createAction('metadata/set_metadata');

export const saveMetadata = createAsyncThunk('metadata/save_metadata', async (payload) => {
  await INKIVE.PageFactory.saveProjectState(payload);

  return payload;
});

export const addToOrderedListChain = createAction('metadata/ordered_list/add_to_chain');
export const removeFromOrderedListChain = createAction('metadata/ordered_list/remove_from_chain');
